__turbopack_context__.v({
  "comingSoonLabel": "WalletRadioCustomLabel-module__nLPIbG__comingSoonLabel",
  "paymentDescription": "WalletRadioCustomLabel-module__nLPIbG__paymentDescription",
  "paymentTitle": "WalletRadioCustomLabel-module__nLPIbG__paymentTitle",
});
